'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164 from "./presto.types$-Two-Factor-Auth-Name$$anon$164.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165 from "./presto.types$-Two-Factor-Auth-Name$$anon$165.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthName$() {
  this.ccc = null;
  this.ccd = false;
  this.cca = null;
  this.ccb = false;
  this.ccg = null;
  this.cch = false;
  this.cce = null;
  this.ccf = false;
  this.cci = null;
  this.ccj = false;
}
export { $c_Lpresto_types$TwoFactorAuthName$ as $c_Lpresto_types$TwoFactorAuthName$ };
$p = $c_Lpresto_types$TwoFactorAuthName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthName$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthName$() {
}
export { $h_Lpresto_types$TwoFactorAuthName$ as $h_Lpresto_types$TwoFactorAuthName$ };
$h_Lpresto_types$TwoFactorAuthName$.prototype = $p;
$p.cIq = (function() {
  if ((!this.ccd)) {
    this.ccc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.ccd = true;
  }
  return this.ccc;
});
$p.zc = (function() {
  if ((!this.ccb)) {
    this.cca = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.ccb = true;
  }
  return this.cca;
});
$p.a2H = (function() {
  if ((!this.cch)) {
    this.ccg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cch = true;
  }
  return this.ccg;
});
$p.cse = (function() {
  if ((!this.ccf)) {
    this.cce = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164.$c_Lpresto_types$TwoFactorAuthName$$anon$164(this);
    this.ccf = true;
  }
  return this.cce;
});
$p.a2O = (function() {
  if ((!this.ccj)) {
    this.cci = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165.$c_Lpresto_types$TwoFactorAuthName$$anon$165(this);
    this.ccj = true;
  }
  return this.cci;
});
var $d_Lpresto_types$TwoFactorAuthName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthName$, "presto.types$TwoFactorAuthName$", ({
  a2g: 1,
  D: 1
}));
export { $d_Lpresto_types$TwoFactorAuthName$ as $d_Lpresto_types$TwoFactorAuthName$ };
var $n_Lpresto_types$TwoFactorAuthName$;
function $m_Lpresto_types$TwoFactorAuthName$() {
  if ((!$n_Lpresto_types$TwoFactorAuthName$)) {
    $n_Lpresto_types$TwoFactorAuthName$ = new $c_Lpresto_types$TwoFactorAuthName$();
  }
  return $n_Lpresto_types$TwoFactorAuthName$;
}
export { $m_Lpresto_types$TwoFactorAuthName$ as $m_Lpresto_types$TwoFactorAuthName$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Name$.js.map
